module.exports = __webpack_public_path__ + "media/newVideo.50a37d58.mp4";